import React, { useState } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import axios from "axios";
import API_URL from '../config/api'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function AddStudent() {
  const navigate=useNavigate()
  const { userArray } = useSelector((state) => state.auth);
  const { list } = useSelector((state) => state.resturants);

  const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        { id: "name", title: "الاسم", type: "text" },
        { id: "username", title: "اسم المستخدم", type: "text" },
        { id: "password", title: "كلمة المرور", type: "text" },
        { id: "password_confirmation", title: "تأكيد كلمة المرور", type: "text" },
        { id: "military_number", title: "الرقم العسكري", type: "text" },
        { id: "rank", title: "الرتبة", type: "text" },
        { id: "workplace", title: "جهة العمل", type: "text" },
        {
          id: "restaurant_id",
          title: "اختار المطعم",
          type: "select",
          options:list,
        },

      ],
    },
  ];
  // const infoData = [
  //   {
  //     id: 0,
  //     title: "معلومات أساسية",
  //     inputs: [
  //       { id: "name", title: "الاسم", type: "text" },
  //       { id: "identity_number", title: "الرقم العسكري", type: "text" },
  //       { id: "rank", title: "الرتبة", type: "text" },
  //       { id: "work_place", title: "جهة العمل", type: "text" },
  //       {
  //         id: "restaurant",
  //         title: "اختار المطعم",
  //         type: "select",
  //         options: ["مطعم معهد الشرطه المستجدين", "مطعم معهد الرتب الاخرى"],
  //       },

  //       // 👇 ضيف الحقول المطلوبة من API
  //       { id: "email", title: "البريد الإلكتروني", type: "email" },
  //       { id: "password", title: "كلمة المرور", type: "password" },
  //       { id: "password_confirmation", title: "تأكيد كلمة المرور", type: "password" },
  //       { id: "phone", title: "رقم الهاتف", type: "text" },
  //       { id: "username", title: "اسم المستخدم", type: "text" },
  //       { id: "national_number", title: "الرقم العسكري", type: "text" },
  //     ],
  //   },
  // ];


  const handleSubmit = async (formData) => {
    console.log(formData);
    
    try {
      
      // لو فيه image لازم FormData
      console.log("FORM DATA:", formData); // 🔥 مهم للتأكد

      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
      // Object.keys(formData).forEach((key) => {
      //   data.append(key, formData[key]);
      // });

      const response = await axios.post(
        `${API_URL}/admin/trainees`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userArray?.access_token}`,

            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response.data);
      alert("تم إضافة المتدرب بنجاح ✅");
navigate('/dashboard/students')
    } catch (error) {
      console.log(Object.values(error.response.data.errors)[0][0])
      alert(Object.values(error.response.data.errors)[0][0]);
    }
  };
  return (
    <div>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"إضافة متدرب جديدة"}
          subtitle={""}
          downloadData={false}
        />
        <CustomForm
          formStructure={infoData}
          image={false}
          onSubmit={handleSubmit}

        />
      </Container>
    </div>
  )
}

export default AddStudent
